import Select2 from '@gameonsports/components/cjs/Select2'
import { useLocation } from '@reach/router'
import React from 'react'
import styled from 'styled-components'
import {
  Regions,
  regionNames,
  regionToLinksMap,
} from '../../../constants/states'

const regionOptions = Object.entries(regionNames).map(([key, value]) => ({
  name: value,
  id: key,
}))

const RegionDropdown = styled(Select2)`
  background-color: transparent;
  color: white;
  border-color: white;
  & + svg {
    fill: white;
  }
`

export const RegionChangerFooter = () => {
  const location = useLocation()
  return (
    <RegionDropdown
      name="x"
      label="Country/Region"
      onChange={e => {
        window.location.assign(
          regionToLinksMap[e.currentTarget.value as Regions],
        )
      }}
      value={location.pathname.startsWith('/uk') ? Regions.UK : Regions.AUNZ}
    >
      {regionOptions.map(({ id, name }) => {
        return (
          <option key={id} value={id}>
            {name}
          </option>
        )
      })}
    </RegionDropdown>
  )
}
